import React from 'react';

import css from '../SetPlan.module.scss';
import Button from '../../../../components/UI/Button';
import PlanChecklist from '../ChecklistsAndContent/PlanChecklist';
import { LearnMoreTopic, Plan } from '../index';
import { PlanPrices, SavingsRewards } from '../../../../utils/prices';

interface Props {
  loading: boolean | undefined;
  flatFees: PlanPrices;
  savings: SavingsRewards;
  onInfoClicked: (plan: Plan) => void;
  onLearnMoreClicked: (learnMoreTopic: LearnMoreTopic, plan: Plan) => void;
  onUpgradeClicked: (plan: Plan) => void;
  onExploreAllPlansClicked: () => void;
  analytics: any;
  flowId: string;
}

const DefaultInfinityPlan = ({
  onInfoClicked,
  flatFees,
  savings,
  loading,
  onLearnMoreClicked,
  onUpgradeClicked,
  onExploreAllPlansClicked,
  analytics
}: Props) => {
  const eventProps = {
    plan: Plan.infinity,
    price: flatFees.infinity,
    skipped: false
  };

  return (
    <>
      <div
        className={`${css.investOptionHeaderContainerMultline} ${css.investOptionHeaderContainer}`}
      >
        <h3 className={css.investOptionHeaderLighter}>
          Free for one month then $14.98/month. Change or cancel your plan
          anytime.
        </h3>
        <img
          src="../../../static/info-icon.svg"
          onClick={() => onInfoClicked(Plan.infinity)}
          data-testid="infinity-info"
        />
      </div>
      <PlanChecklist
        plan="defaultInfinity"
        onLearnMoreClicked={onLearnMoreClicked}
        savings={savings}
      />
      <div className={css.investCtaSticky}>
        <Button
          text="Try 1-month free"
          loading={loading}
          onClick={() => {
            analytics.trackEvent('Registration Invest Plan Action', {
              eventProps
            });
            onUpgradeClicked(Plan.infinity);
          }}
          data-e2e="upgrade-infinity"
        />
        <div className={css.investSlimmerCta}>
          <Button
            outline
            text="No thanks"
            loading={loading}
            onClick={() => {
              analytics.trackEvent('Registration Plans Page Viewed', {
                eventProps
              });
              onExploreAllPlansClicked();
            }}
            data-e2e="all-plans-info"
          />
        </div>
      </div>
    </>
  );
};

export default DefaultInfinityPlan;
